import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import AzureKeyVaultResourceDetailsView from "./AzureKeyVaultResourceDetailsView";

const AzureKeyVaultKeyDetailsView = ({ entityData }) => {
  return (
    <AzureKeyVaultResourceDetailsView entityData={entityData}>
      <Box display="flex" flexDirection="column" gap={2}>
        {entityData?.azure_keyvault_key_data?.operations && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Allowed Operations</Typography>
            </Box>
            <Box ml={2} display="flex" alignItems="center" gap={0.5}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <TextIntegrationStyle
                  title=""
                  value={entityData.azure_keyvault_key_data.operations.join(
                    ", "
                  )}
                />
              </Box>
            </Box>
          </Box>
        )}
        {entityData?.azure_keyvault_key_data?.key_rotation_enabled && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Rotation Status</Typography>
            </Box>
            <Box ml={2} display="flex" flexDirection="column" gap={0.5}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <TextIntegrationStyle
                  title=""
                  value={
                    entityData?.azure_keyvault_key_data?.key_rotation_enabled
                      ? "Enabled"
                      : "Disabled"
                  }
                />
              </Box>
            </Box>
          </Box>
        )}
        {entityData?.azure_keyvault_key_data?.exportable !== undefined && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Exportable</Typography>
            </Box>
            <Box ml={2} display="flex" flexDirection="column" gap={0.5}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <TextIntegrationStyle
                  title=""
                  value={
                    entityData?.azure_keyvault_key_data?.exportable
                      ? "True"
                      : "False"
                  }
                />
              </Box>
            </Box>
          </Box>
        )}
        {entityData?.azure_keyvault_key_data?.key_rotation_enabled !==
          undefined && (
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Key Rotation Status</Typography>
            </Box>
            <Box ml={2} display="flex" flexDirection="column" gap={0.5}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <TextIntegrationStyle
                  title=""
                  value={
                    entityData?.azure_keyvault_key_data?.key_rotation_enabled
                      ? "Enabled"
                      : "Disabled"
                  }
                />
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </AzureKeyVaultResourceDetailsView>
  );
};

export default AzureKeyVaultKeyDetailsView;
